import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import $ from 'jquery';

const GLOBAL = require('../../Globals');

class LoanManage extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			acyear : '',
			year : (new Date()).getFullYear(),
			payhead : '',
			depart : [],
			accyear : [],
			payhe : [],
			emp : [],
			desig : '',
			employee : '',
			month : '',
			amt : '',
			dues : '',
			_message : '',
			alertClass :'',
			_redirect : false,
			 posts: [],
			 salary : [],
			 modal: false,
			 adamt : '',
		}
		this.onChange = this.onChange.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.toggle = this.toggle.bind(this);
	}
	
	toggle(){
		this.setState({
		  modal: !this.state.modal
		});
	}
	
	onClick(e){
		
		document.getElementById("salform").reset();
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
		this.getdata();
	}
	
	onSubmit(e){
		e.preventDefault();
		$("#showLoader").show();
		PostData('payroll/editloans',this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson.status == '1' ){
				this.getdata();
				this.toggle();
			}
			else{
				this.getdata();
				this.toggle();
			}
		});
	}
	
	onUpdate(id,e){
		alert(id+' '+e.target.id);
		this.state.employee = id;
		this.state.adamt = e.target.id;
		this.setState({
		  modal: !this.state.modal
		});
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getacyear();
		this.getdeduction();
	}
	
	/** get Academic Year **/
	getacyear(){
		
		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					accyear : responseJson
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear : academic
				});
				$('#year option').eq(1).prop('selected', true).trigger('change');
			}
		});
	}
	
	getdeduction(){
		$("#showLoader").show();
		GetData('payroll/getdeduction').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					data : responseJson
				});
			}
		});
	}
	
	getdata(){
		
		var ac = $("#year").val();
		var month = $("#month").val();
		$("#showLoader").show();
		GetData('payroll/getloansbymonth/'+ac+'/'+month).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	getdeduamt(emp){
		
		var dat = [];
		
		if(this.checkdedamt(emp)!=''){
			
			dat.push(<td>{this.checkdedamt(emp)}</td>);
		}
		else{
			
			dat.push(<td>{this.checkloanamt(emp)}</td>);
		}
		
		return dat;
	}
	
	checkloanamt(emp){
		
		var bstate = false;
		
		for(var i=0; i<this.state.posts.length; i++){
			
			if(this.state.posts[i].employee == emp){
				
				bstate = (this.state.posts[i].amount)-(this.state.posts[i].paidamount);
			}
			else{
				
				bstate = false;
			}
		}
		
		return bstate;
	}
	
	checkdedamt(emp){
		
		var bstate = false;
		var ac = $("#year").val();
		var year = this.state.year;
		var month = $("#month").val();
		
		for(var i=0; i<this.state.data.length; i++){
			
			if(this.state.data[i].acyear == ac && this.state.data[i].year == year && this.state.data[i].month == month && this.state.data[i].employee == emp){
				
				bstate = this.state.data[i].amount;
			}
			else{
				
				bstate = false;
			}
		}
		
		return bstate;
	}
	
  render() {
	
	/** set month in select box **/
	this.month = [
		{value : '', name: 'Select Month'},
		{value : '01', name: 'January'},
		{value : '02', name: 'February'},
		{value : '03', name: 'March'},
		{value : '04', name: 'April'},
		{value : '05', name: 'May'},
		{value : '06', name: 'June'},
		{value : '07', name: 'July'},
		{value : '08', name: 'August'},
		{value : '09', name: 'September'},
		{value : '10', name: 'October'},
		{value : '11', name: 'November'},
		{value : '12', name: 'December'}
	];
	
	var dept = this.state.depart;
	var acyear = this.state.accyear;
	var pay = this.state.payhe;
	
	if(this.state.acyear!='' && this.state.month!=''){
		
		$("#loantab").show();
	}
	else{
		
		$("#loantab").hide();
	}
	
	var salad = $("#adamt").val();
	
	if(parseFloat(salad) > parseFloat(this.state.adamt)){
		
		$("#adamt").val('');
		this.state.adamt = '';
		alert('please check pending amount');
	}
	   
    return (
		<div className="animated fadeIn">
			<div className={this.state.alertClass}>
				{this.state._message}
			</div>
			<Row>
			  <Col md="12">
				<Card>
				  <form action="" method="post" role="form" id="salform" encType="multipart/form-data" onSubmit={this.onSubmit} >
					<CardHeader>
						<strong>Loan/Advance Management</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						Academic Year : &nbsp;&nbsp;
						<select name="acyear" onChange={this.onChange} required id="year">
							<option value="">Select Academic Year</option>
							{
								acyear.map(function (item) {
									return <option value={item.id }>{item.value}</option>;
								})
							}
						</select>&nbsp;&nbsp;
						Month : &nbsp;&nbsp;
						<select name="month" onChange={this.onChange} required id="month">
							{this.month.map((e, key) => {
								return <option key={key} value={e.value}>{e.name}</option>;
							})}		
						</select>
					</CardHeader>
					<CardBody id="loantab">
					 <Row>
					  <Col md="12">
						<Table responsive bordered  id="atttable">
						  <thead>
							<tr>
								<th>S.No</th>
								<th>Staff Name</th>
								<th>Amount</th>
								<th>No of Dues</th>
								<th>Total Paid</th>
								<th>Pending</th>
								<th>Deduction Amount</th>
								<th>Manage</th>
							</tr>
						  </thead>
						  <tbody>
							{this.state.posts.map((item,i) =>
						 
								<tr key = {item}>
									<td>{i+1}</td>
									<td>{item.empname}</td>
									<td>{item.amount}</td>
									<td>{item.noofdues}</td>
									<td>{item.paidamount}</td>
									<td>{parseFloat(item.amount)- parseFloat(item.paidamount)}</td>
									{this.getdeduamt(item.employee)}
									<td>
										<Button name="editacyear" className="btn btn-info btn-sm" id={parseFloat(item.amount)- parseFloat(item.paidamount)} onClick={this.onUpdate.bind(this,item.employee)} >Edit</Button>
									</td>
								</tr>
							)}
						  </tbody>
						</Table>
						<Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
						  <ModalHeader toggle={this.toggle}>Select</ModalHeader>
						  <ModalBody>
							<Row>
							  <Col md="12">
							   <FormGroup>
								<Label htmlFor="name">Deduction Amount <span className="text-danger">*</span></Label>
								<input type="number" name="adamt" id="adamt" value={this.state.adamt} className="form-control" onChange={this.onChange}/>
							   </FormGroup>
							  </Col>
							</Row>
						  </ModalBody>
						  <ModalFooter>
							<Button type="submit" color="primary" onClick={this.onSubmit}>Submit</Button>
							<Button color="secondary" onClick={this.toggle}>Cancel</Button>
						  </ModalFooter>
					  </Modal>
					  </Col>
					 </Row>
					</CardBody>
				  </form>
				</Card>
			  </Col>
			</Row>
		</div>
	)
  }
}

export default LoanManage;


// WEBPACK FOOTER //
// ./src/payroll/Loan/LoanManage.js